// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__5-JDI","logOut":"styles_logOut__sFL5L","notYetAgreedWrapper":"styles_notYetAgreedWrapper__Ghi3b"};